import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Portfolio from "../components/Portfolio";
import InstagramFeed from "../components/InstagramFeed";

export default function PortfolioPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="Our Work" title="Portfolio & Trends" subtitle="A glimpse of the nails, lashes and looks crafted at VIIMII STUDIO." />
      <Portfolio />
      <InstagramFeed />
    </>
  );
}
